import { SideNavItem } from './models/sideNavItem';

export const SIDENAV_ITEMS_PUBLISHER: Array<SideNavItem> = [
  {
    reportId: 'publisherTrustIndex',
    title: 'Publisher Trust Index',
    id: 'publisher-trust-index',
    mapId: 'publisher-trust-index',
    active: false,
    groups: ['app', 'ctv', 'domain']
  },
  {
    reportId: 'publisherGrossing',
    title: 'Top Grossing',
    id: 'publisher-grossing',
    mapId: 'publisher-grossing',
    active: false,
    groups: ['app', 'ctv']
  },
  {
    reportId: 'publisherReach',
    title: 'Reach',
    id: 'publisher-reach',
    mapId: 'publisher-reach',
    active: false,
    groups: ['app', 'ctv']
  },
  {
    reportId: 'coppaIndex',
    title: 'Child-Directed Apps',
    id: 'publisher-coppa',
    mapId: 'publisher-coppa',
    active: false,
    groups: ['app', 'ctv'],
    icon: 'icon-publisher-coppa.svg'
  },
  {
    reportId: 'mfaIndex',
    title: 'Made For Advertising',
    id: 'high-risk-mfa',
    mapId: 'high-risk-mfa',
    active: false,
    groups: ['ctv', 'app', 'domain']
  }
];
